export const isAdminAppPath = (pathname) => /^\/(?:admin|c)(?:\/|$)/.test(pathname);

export function applyAppIdentity(pathname) {
  const admin = isAdminAppPath(pathname);
  document.querySelector('link[rel="manifest"]')?.setAttribute("href", admin ? "/admin/manifest.webmanifest" : "/manifest.json");
  document.querySelector('link[rel="apple-touch-icon"]')?.setAttribute("href", admin ? "/admin/icon-192.png" : "/apple-touch-icon.png");
  document.querySelector('meta[name="apple-mobile-web-app-title"]')?.setAttribute("content", admin ? "Sophia Admin" : "Sophia Sweeps");
  document.querySelector('meta[name="theme-color"]')?.setAttribute("content", admin ? "#0A0A0B" : "#D4AF37");
}
